import axiosInstance from "core/api/axiosInstance";
import { validateVipUsageFilters } from "../model/vipUsageDates";
import { buildVipUsageReport } from "../model/vipUsageModel";
function readList(payload, label) {
  if (!Array.isArray(payload?.data) || (payload.code !== undefined && payload.code !== 0))
    throw new Error(payload?.message || `Respuesta inválida de ${label}.`);
  if (
    payload.pagination?.hasMore ||
    (Number.isFinite(Number(payload.count)) && Number(payload.count) > payload.data.length)
  )
    throw new Error(`La respuesta de ${label} está incompleta; falta paginación del backend.`);
  return payload.data;
}
export async function getVipUsageService(filters, signal) {
  try {
    const invalid = validateVipUsageFilters(filters);
    if (invalid) throw new Error(invalid);
    const endpoint = process.env.REACT_APP_USO_VIP_API_URL;
    const query = new URLSearchParams({ startDate: filters.startDate, endDate: filters.endDate });
    if (endpoint) {
      query.set("startAt", `${filters.startDate}T00:00:00-05:00`);
      query.set("endAt", `${filters.endDate}T23:59:59.999-05:00`);
      query.set("dateBasis", "entry");
      query.set("timeZone", "America/Bogota");
      if (filters.groupId) query.set("groupId", String(filters.groupId));
      if (filters.plate) query.set("plate", filters.plate.trim());
      const { data } = await axiosInstance.get(
        `${endpoint}${endpoint.includes("?") ? "&" : "?"}${query}`,
        { signal }
      );
      const visits = readList(data, "visitas VIP");
      if (!Array.isArray(data.groups))
        throw new Error("El informe VIP debe incluir el catálogo de grupos.");
      return {
        success: true,
        report: buildVipUsageReport({ source: "visits", visits, groups: data.groups }, filters),
      };
    }
    const urls = [
      "/api/tp/get-iserra-groups",
      "/api/tp/get-iserra",
      "/api/tp/get-iserra-vehicles/all",
      `/api/tp/get-iserra-history?${query}`,
    ];
    const results = await Promise.allSettled(urls.map((url) => axiosInstance.get(url, { signal })));
    if (signal?.aborted) return { success: false, isCanceled: true };
    const warnings = [];
    const payloads = results.map((result, index) => {
      if (result.status === "fulfilled") return result.value.data;
      if (index < 2) throw result.reason;
      warnings.push(
        index === 2
          ? "No se pudieron consultar los últimos tiempos VIP."
          : "No se pudo consultar el historial de movimientos."
      );
      return null;
    });
    const groups = readList(payloads[0], "grupos"),
      members = readList(payloads[1], "vehículos registrados");
    const details = payloads[2] ? readList(payloads[2], "vehículos actuales") : [];
    const events = payloads[3] ? readList(payloads[3], "historial") : [];
    if (payloads[2] && !Array.isArray(payloads[2].time))
      throw new Error("La respuesta de vehículos actuales no incluye tiempos válidos.");
    return {
      success: true,
      report: buildVipUsageReport(
        { groups, members, details, times: payloads[2]?.time || [], events, warnings },
        filters
      ),
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.message || error.message || "No se pudo consultar Uso de VIP.",
      isCanceled: signal?.aborted || error.code === "ERR_CANCELED",
    };
  }
}
